import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Building = createReactComponent("Building", ["svg", defaultAttributes, [["rect", {
  x: "4",
  y: "2",
  width: "16",
  height: "20",
  rx: "2",
  ry: "2",
  key: "1p0e78"
}], ["path", {
  d: "M9 22v-4h6v4",
  key: "ujjh2e"
}], ["path", {
  d: "M8 6h.01",
  key: "1wzyqp"
}], ["path", {
  d: "M16 6h.01",
  key: "1lnkkb"
}], ["path", {
  d: "M12 6h.01",
  key: "j7ydwe"
}], ["path", {
  d: "M12 10h.01",
  key: "11wgo0"
}], ["path", {
  d: "M12 14h.01",
  key: "rao6x9"
}], ["path", {
  d: "M16 10h.01",
  key: "1yhyjk"
}], ["path", {
  d: "M16 14h.01",
  key: "1tqadc"
}], ["path", {
  d: "M8 10h.01",
  key: "9s5hzm"
}], ["path", {
  d: "M8 14h.01",
  key: "2jug5y"
}]]]);
export default Building;